__turbopack_context__.v({
  "button": "ProductAddToCartButton-module-scss-module__-Hom1q__button",
  "buttonContent": "ProductAddToCartButton-module-scss-module__-Hom1q__buttonContent",
  "icon": "ProductAddToCartButton-module-scss-module__-Hom1q__icon",
  "saveForLater": "ProductAddToCartButton-module-scss-module__-Hom1q__saveForLater",
});
